module.exports = __webpack_public_path__ + "img/artist.579e0e04.png";